import { render, staticRenderFns } from "./MovementWithoutPremium.vue?vue&type=template&id=4965a584&scoped=true&"
import script from "./MovementWithoutPremium.vue?vue&type=script&lang=js&"
export * from "./MovementWithoutPremium.vue?vue&type=script&lang=js&"
import style0 from "./MovementWithoutPremium.vue?vue&type=style&index=0&id=4965a584&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4965a584",
  null
  
)

export default component.exports